// Format camelCase enum values to readable strings
export function formatEnumValue(value: string): string {
  // Handle specific cases
  const specialCases: Record<string, string> = {
    'piezoelectricCrystal': 'Piezoelectric Crystal',
    'figure8': 'Figure 8',
    'multiPattern': 'Multi-Pattern',
  };

  if (specialCases[value]) {
    return specialCases[value];
  }

  // Default: split camelCase and capitalize
  return value
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (str) => str.toUpperCase())
    .trim();
}

// Card layouts are tight, so the longest terms get abbreviated there.
// Full names are kept everywhere else, including structured data.
export function formatEnumValueCompact(value: string): string {
  return formatEnumValue(value).replace(/\bPiezoelectric\b/, 'Piezo');
}
